import Shimmer from "@/utils/shimmer";
import LinkWrapper from "../LinkWrapper";
import Image from "next/image";
import TextBanner from "../GoldenTextBanner";
import FaIndianRupeeSign from "../SVG/Fontawesome/FaIndianRupeeSign";
import { useRouter } from "next/router";
import { getStudentIdLS } from "@/utils/auth";
import IconGeneric from "../SVG";
import { updateCourseLead } from "@/helpers/api/service/Course";
import { ICourseCardV2ListItem } from "./interfaces";
import DiscountBadge from "../Badge/Discount";
import { selectUser } from "@/store/slices/auth";
import { useSelector } from "react-redux";

const CourseCardV2LinkWrapper = (props: { children: JSX.Element | JSX.Element[], assortment_id: number, className: string; rel: string; href: string; }) => {
  // authContext causing re render when user is set afterwards. difference of 1-2 ms  old 5ms vs new 3.6ms
  const router = useRouter();
  const user = useSelector(selectUser);

  const handleClick = (e: any) => {
    e.preventDefault();
    updateCourseLead({
      webStudentId: getStudentIdLS() as string,
      assortmentId: String(props.assortment_id),
      sourceUrl: router.asPath,
      isLoggedIn: user.id ? 1 : 0
    }).catch().then(() => router.push(`/course/${props.assortment_id}`))

  }
  return <LinkWrapper
    className={props.className}
    rel={props.rel}
    onClick={handleClick}
    href={props.href}
  >
    {props.children}
  </LinkWrapper>
}

const CourseCardV2ListItem = (props: { item: ICourseCardV2ListItem, category?: string; }) => {
  const item = props.item;
  const bgClassName = props.category ? `bg-${props.category}` : "bg-slate-700";
  
  if(!item.assortment_id) return <></>;

  return <div className="card bg-secondary p-0 flex flex-col 2xl:flex-row grow">
    <CourseCardV2LinkWrapper
      className="block no-underline lg:basis-2/5 shrink-0 space-y-4"
      rel="noopener noreferrer"
      assortment_id={item.assortment_id}
      href={`/course/${item.assortment_id}`}
    >
      <div className="block h-full lg:hidden space-y-2 p-4">
        <h2 style={{ WebkitTextFillColor: "transparent" }} className="my-0 bg-gradient-to-r from-[#B89035] via-[#E2B82A] to-[#B89035] !bg-clip-text font-bold">{item.title || item.display_name}</h2>
        <div className="flex gap-4">
          {item.language && <span className={`${bgClassName} text-white rounded-md p-1 px-4 flex items-center gap-1 whitespace-nowrap text-xs`}>{item.language}</span>}
          {item.live && <span className={`${bgClassName} text-white rounded-md p-1 px-4 flex items-center gap-2 whitespace-nowrap text-xs`}><span className="inline-block w-2 h-2 bg-red-500 rounded-[50%]"></span> LIVE CLASSES</span>}
        </div>
      </div>

      <div className="h-full flex flex-col !my-0">
        <div className={`rounded-tl-md  h-full flex flex-col relative gap-10 ${item.imgTitle ? `justify-end ${bgClassName}` : `justify-center`}  text-white`}>
          {item.imgTitle && <p className="text-xm sm:text-lg  w-3/4 mx-auto text-center text-[#F1D7A8] absolute inset-0 top-4 sm:top-12 my-0">{item.imgTitle}</p>}
          <Image
            className="my-0 w-full "
            src={item.demo_video_thumbnail}
            alt={item.title}
            width={384}
            height={216}
            placeholder="blur"
            blurDataURL={Shimmer(384, 216)}
          />
        </div>

        {item.textBanner &&
          <div className="h-max block">
            <TextBanner className="h-full !py-2 rounded-bl-md" text={item.textBanner} />
          </div>
        }
      </div>
    </CourseCardV2LinkWrapper>

    <div className="px-4 h-full grow flex flex-col justify-between space-y-4">
      <CourseCardV2LinkWrapper
        assortment_id={item.assortment_id}
        className="no-underline basis-2/3   px-2"
        rel="noopener noreferrer"
        href={`/course/${item.assortment_id}`}
      >
        <div className="space-y-2">
          <div className="hidden lg:block space-y-2">
            <h2 style={{ WebkitTextFillColor: "transparent" }} className="my-0 mt-4 bg-gradient-to-r from-[#B89035] via-[#E2B82A] to-[#B89035] !bg-clip-text font-bold">{item.title || item.display_name}</h2>
            <div className="flex gap-4">
              {item.language && <span className={`${bgClassName} text-white rounded-md p-1 px-4 flex items-center gap-1 whitespace-nowrap text-sm`}>{item.language}</span>}
              {item.live && <span className={`${bgClassName} text-white rounded-md p-1 px-4 flex items-center gap-2 whitespace-nowrap text-sm`}><span className="inline-block w-2 h-2 bg-red-500 rounded-[50%]"></span> LIVE CLASSES</span>}
            </div>
          </div>

          <div className="flex gap-2 justify-center lg:justify-start text-xs lg:text-sm border-b-2 py-2 border-[#E5B86D]">
            <span className="w-max">Starts on <strong>{item.start_date}</strong></span>|
            <span className="w-max">Ends on <strong>{item.end_date}</strong></span>
          </div>

          {
            !!item.svgList?.length && <div className="border-b-2 !mt-0 py-2 border-[#E5B86D]">
              <ul className="flex justify-between pl-0  my-0 items-center">
                {item.svgList?.map((subItem, index) => <li key={index.toString()} className="flex items-center gap-2 flex-col">
                  {subItem.svg && <IconGeneric name={subItem.svg} className="w-6 h-6 text-accent" />}
                  {subItem.text && <span className="block text-center text-xs max-w-[40px]">{subItem.text}</span>}
                </li>)}
              </ul>
            </div>
          }

        </div>
      </CourseCardV2LinkWrapper>

      <CourseCardV2LinkWrapper
        assortment_id={item.assortment_id}
        rel={`noopener noreferrer ${item.variant_id ? "noindex nofollow" : ""}`}
        className="flex gap-2 items-center justify-between px-4 !mb-4 !no-underline"
        href={
          item.variant_id
            ? `/checkout?variant_id=${item.variant_id}&url=`
            : `/course/${item.assortment_id}`
        }
      >
        <div className="flex flex-col py-0 gap-2 justify-between">
          <strong style={{ WebkitTextFillColor: "transparent" }} className="whitespace-nowrap text-2xl my-0 bg-gradient-to-r from-[#B89035] via-[#E2B82A] to-[#B89035] !bg-clip-text font-bold">
            <FaIndianRupeeSign className="mr-1 text-[#B89035] " />{item.display_price}
          </strong>
          <div className="flex flex-wrap items-center">
            {item.base_price &&
            <s className="text-gray-400">
              <FaIndianRupeeSign className="mr-1 text-inherit" />{item.base_price}
            </s>
            }
            {item.base_price && <DiscountBadge base_price={item.base_price} display_price={item.display_price} className="flex text-green-700 px-1 py-0.5 text-sm p-1"/> }
          </div>
        </div>
        <button className="btn-primary max-w-full px-4 sm:px-8">{item.ctaText || "Buy Now"}</button>
      </CourseCardV2LinkWrapper>
    </div>
  </div>
};

export default CourseCardV2ListItem;